export function DraftConflictWarning({ field }: { field: string }) {
  return (
    <p className="drawer-draft-conflict" role="alert">
      This ticket changed remotely. Your local {field} is preserved for inspection and copying,
      but saving is blocked to prevent either version being overwritten.
    </p>
  );
}
